module.exports = __webpack_public_path__ + "static/img/hb_54-min.817cde4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_54-min.png
// module id = 3Vku
// module chunks = 1